import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-add-to-wishlist',
  styleUrls: ['./add-to-wishlist.component.scss'],
  templateUrl: './add-to-wishlist.component.html',
  standalone: true,
  imports: [NgClass],
})
export class AppAddToWishlistComponent {
  @Input() isInWishlist: boolean;
  @Output() addToWishlistEvent = new EventEmitter<MouseEvent>();
  @Output() removeFromWishlistEvent = new EventEmitter<MouseEvent>();
  @Output() checkLoggedUserEvent = new EventEmitter();

  @Input() isProductPage: boolean = true;

  isHovering = false;

  constructor() {
    this.isInWishlist = false;
  }

  checkLoggedUser(): void {
    this.checkLoggedUserEvent.emit();
  }

  addToWishlist(event: MouseEvent): void {
    this.addToWishlistEvent.emit(event);
  }

  removeFromWishlist(event: MouseEvent): void {
    this.removeFromWishlistEvent.emit(event);
  }

  toggleWishlist(event: MouseEvent): void {
    this.checkLoggedUser();

    if (this.isInWishlist) {
      this.removeFromWishlist(event);
      return;
    }

    this.addToWishlist(event);
  }

  wishlistIcon(): Record<string, boolean> {
    return {
      fas: (this.isInWishlist && !this.isHovering) || (!this.isInWishlist && this.isHovering),
      fa: (!this.isInWishlist && !this.isHovering) || (this.isInWishlist && this.isHovering),
    };
  }
}
